/** @jsx jsx */
import { useMemo, useCallback, memo } from 'react';

import { css, jsx } from '@emotion/core';
import styled from '@emotion/styled';

import { blue } from '~/theseus/styles/core';

const formSelectorStyles = css`
  & > ul {
    list-style: none;
    overflow: auto;
    width: 400px;
    max-height: 250px;
    padding: 1px;
  }

  & > ul li::before {
    content: "\\200B";
  }

  label {
    display: block;
    padding-bottom: 10px;
    font-size: 14px;
    font-weight: 500;
    color: #00000033;
  }
`;

const FormItemCore = styled.li`
  &:not(:first-of-type) {
    margin: 10px auto;
  }

  border: none;
  padding: 6px 10px;
  margin-top: 6px;
  font-size: 18px;
  color: ${blue};
  background: #fff;
  box-shadow: 0 0 0 1px #00000025;
  border-radius: 2px;

  &:hover,
  &:focus {
    color: #0767da;
    outline: 2px ${blue} solid;
    cursor: pointer;
  }
`;

interface FormItemProps {
  name: string;
  id: string;
  onSelect: (formId: string) => void;
}

const FormItem: React.FC<FormItemProps> = memo(({
  name, id, onSelect,
}) => {
  const handleSelect = useCallback(() => onSelect(id), [onSelect, id]);
  return (
    <FormItemCore
      role="option"
      onClick={handleSelect}
      aria-label={`Choose lead ad form - ${name}`}
    >
      { name }
    </FormItemCore>
  );
});

interface Props {
  forms: Form[];
  onSelect: (formId: string) => void;
}
const FormPicker: React.FC<Props> = (props) => {
  const { onSelect, forms } = props;

  const formList = useMemo(() => forms.map(form => (
    <FormItem
      id={form.id}
      key={form.id}
      onSelect={onSelect}
      name={form.name}
    />
  )), [forms, onSelect]);

  return (
    <div css={formSelectorStyles}>
      <div id="form-list-label">Choose a Saved Lead Ads Form</div>
      <ul
        aria-labelledby="form-list-label"
        role="listbox"
      >
        {formList}
      </ul>
    </div>
  );
};

export default FormPicker;
